<template lang="html">

  <section class="buttons">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="h2">Instellingen</h4>
            <div style="margin-top: 30px; margin-bottom: 30px;">
              <div>
              </div>
              <div>
<!--                <form action="#" @submit="saveSettings()">-->
<!--                  <div class="form-group">-->
<!--                    <label class="label">Aantal consecutieve gesprekken</label>-->
<!--                    <div class="input-group">-->
<!--                      <input type="text" class="form-control" v-model="consecutiveCalls" ref="consecutiveCalls" placeholder="Voornaam" id="consecutiveCalls">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <b-button class="btn btn-success" @click="saveSettings()">Opslaan</b-button>-->
<!--                </form>-->
              </div>
            </div>

            <h5 style="margin-bottom:24px">Audiobestanden</h5>
            <div class="col-md-4 grid-margin stretch-card" v-for="audiofile in audiofilesDb" v-bind:key="audiofile.audiofile_id">
              <div class="card">
                <div class="card-body">
                  <h4 class="h4">{{audiofile.filename}}</h4>
                </div>
                <div style="position:relative; padding-bottom: 16px">
                  <b-col class="text-right">
                    <b-button-group>
                      <b-button-group>
                        <b-button variant="danger" class="icon-btn" @click="deleteAudiofile(audiofile.audiofile_id)">
                          <i class="mdi mdi-delete"></i>
                        </b-button>
                      </b-button-group>
                    </b-button-group>
                  </b-col>
                </div>
              </div>

            </div>

            <div v-if="isLoading" class="circle-loader"></div>
            <div>
              <input id="fileupload" ref="file" @change="filechange" class="file-upload-browse btn btn-primary" type="file" accept="audio/*" hidden/>
              <button class="file-upload-browse btn btn-primary" v-if="isLoading === false" @click="chooseFiles()" type="button">Nieuw audiobestand toevoegen</button>
<!--              <button class="file-upload-browse btn btn-primary" v-if="fileHasChanged === true" @click="uploadFiles()" type="button">Upload bestand</button>-->

            </div>

          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import Modal from '../modals/Modal'
import axios from 'axios'
import store from '../../store'
let server = require('../../server')
export default {
  name: 'buttons',
  components: {
    Modal
  },
  data () {
    return {
      users_db: [],
      audiofilesDb: [],
      isLoading: false,
      audiofilesDbHeaders: [
        {
          key: 'filename',
          label: 'Bestandsnaam'
        },
        {
          key: 'audiofile_id',
          label: 'Verwijder'
        }
      ],
      files: '',
      filename: '',
      fileHasChanged: false
    }
  },
  computed: {
    role () {
      return store.state.role
    },
    user () {
      return store.state.user
    },
    office () {
      return store.state.office
    },
    officeString () {
      return store.state.officeString
    }
  },
  async created () {
    await this.getAllAudiofilesByOfficeId(this.office.toString())
  },
  methods: {
    async createAudiofile () {
      this.isLoading = true
      this.errors = []
      let self = this
      this.isSaveSuccessful = false

      try {
        let postData = new FormData()
        console.log('creating postData...')
        postData.append('office', self.office)
        postData.append('file', self.files)
        postData.append('user', JSON.stringify(self.user))
        postData.append('office', self.office)
        console.log('this.office = ' + self.office.toString())

        let url = '/upload_audiofile'
        await axios({
          method: 'post',
          url: server.SERVER_URL + url,
          data: postData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json'
          }
        }).then(async function (response) {
          self.isSaveSuccessful = true
          console.log('response after uploadign file: ')
          console.log(response.data)
          self.isLoading = false
          await self.getAllAudiofilesByOfficeId(self.office.toString())
        })
      } catch (e) {
        console.error('Error while trying to upload audiofile!')
        console.error(e)
      }
    },
    async getAllAudiofilesByOfficeId (officeId) {
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/get_all_audiofiles_by_office_id/' + officeId
        })
          .then(function (response) {
            console.log('Audiofiles =')
            console.log(response.data)
            self.audiofilesDb = response.data
          })
      } catch (e) {
        console.log('Error while trying to get audiofiles!!')
        console.log(e)
      }
    },
    async deleteAudiofile (audiofileId) {
      console.log('Preparing to delete audiofile with id: ' + audiofileId)
      let officeId = this.office.toString()
      let i = this.audiofilesDb.map(item => item.audiofile_id).indexOf(audiofileId)
      this.audiofilesDb.splice(i, 1)
      // this.user_id.splice(i, 1)
      this.$forceUpdate()
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/delete_audiofileby_audiofile_id/' + audiofileId
        })
          .then(async function (response) {
            await self.getAllAudiofilesByOfficeId(officeId)
          })
      } catch (e) {
        console.log('Error while trying to get contacts by campaign_id')
        console.log(e)
      }
    },
    async getOfficeSetting () {
    },
    chooseFiles () {
      document.getElementById('fileupload').click()
    },
    async saveSettings () {
      try {
        let postData = {
          consecutiveCalls: this.consecutiveCalls,
          officeId: this.office
        }
        await axios({
          method: 'post',
          url: server.SERVER_URL + '/update_office_settings',
          data: postData
        })
      } catch (e) {
        console.log('Error while trying to update office settings!')
        console.log(e)
      }
    },
    filechange (e) {
      console.log('filechange method triggered!')
      this.files = this.$refs.file.files[0]
      this.filename = this.files.name
      this.fileHasChanged = true

      this.createAudiofile()
    }
  }
}
</script>

<style scoped lang="scss">
// utilities
.overflow-hidden {
  overflow: hidden;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.d-flex {
  display: flex;
}
.align-items-center {
  align-items: center;
}
.justify-content-between {
  justify-content: space-between;
}
// reset
button {
  outline: inherit;
  cursor: pointer;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/basic-elements/settings.vue